import React from 'react'
import './Evaluation.css'

export default function Evaluation() {
  const Criteria = [
    {
        heading: "Data Interpretation",
        desc: "Participants will be assessed on their ability to interpret and analyze the provided data, transforming raw figures into a compelling narrative that effectively conveys the underlying story.",
        marks: "5",
        pic: "/evaluation_pic1.png"
    },
    {
        heading: "Report Presentation",
        desc: "The usability and aesthetic appeal of the report will be evaluated. Emphasis will be placed on intuitive navigation, clarity, and overall user experience.",
        marks: "5",
        pic: "/evaluation_pic2.png"
    },
    {
        heading: "Video Presentation",
        desc: "While optional, participants who choose to produce a video presentation will gain additional points. The video should detail their approach to the challenge, methodology, and the insights derived from the data in a concise, engaging, and informative manner.",
        marks: "5",
        pic: "/evaluation_pic3.png"
    },
    {
        heading: "Presentation/Communication Skills",
        desc: "The clarity, coherence, and effectiveness of the participants' oral communication will be critically assessed. This includes the ability to present complex data in an accessible manner.",
        marks: "5",
        pic: "/evaluation_pic4.png"
    },
    {
        heading: "LinkedIn Content Writing",
        desc: "Participants will be evaluated on the quality of their LinkedIn content. This should encapsulate the insights gained, provide recommendations for improvements, and reflect on the overall experience of the hackathon.",
        marks: "5",
        pic: "/evaluation_pic5.png"
    }
]


    return (
        <div>
            <p className='DatasetHeading'>EVALUATION CRITERIA</p>
            <table className='tableSection'>
                <thead >
                    <tr className='tableHeader'>
                        <th className='tableHeader1'>Criteria</th>
                        <th className='tableHeader2'>Points</th>
                    </tr>
                </thead>
                {
                    Criteria?.map((e, id) => {
                        return (
                            <tbody key={id}>
                                <tr className='tableRow' style={{ backgroundColor: id % 2 === 0 ? "rgba(234, 236, 240, 0.12)" : "rgba(156, 235, 233, 0.2)" }}>
                                    <td className='evaluationImageAndDesc'>
                                        <img src={e?.pic} alt='evaluation' className='evaluationImage'></img>
                                        <div className='evaluationHeadingAndDesc'>
                                            <p className='evaluationHeading'>{e?.heading}</p>
                                            <span className='evaluationDesc'>{e?.desc}</span>
                                        </div>
                                    </td>
                                    <td className='evaluationPoints'>{e?.marks}</td>
                                </tr>
                            </tbody>
                        )
                    })
                }
            </table>
            <p className='additionalText' style={{ backgroundColor: "rgba(156, 235, 233, 0.2)", padding: "10px", borderRadius: "10px" }}>Showcase your talent across these dimensions and stand out as a top performer in the KSR Datavizon Power BI Challenge!</p>
        </div>
    )
}
